/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _company_size_label__unknown_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Inconnue' }],
    'fr',
);

export function company_size_label__unknown(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _company_size_label__unknown_fr.format(args) as unknown as string;
    }

    return _company_size_label__unknown_fr.format(args) as unknown as string;
}

const _company_size_label__very_small_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Très petite' }],
    'fr',
);

export function company_size_label__very_small(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _company_size_label__very_small_fr.format(args) as unknown as string;
    }

    return _company_size_label__very_small_fr.format(args) as unknown as string;
}

const _company_size_label__small_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Petite' }],
    'fr',
);

export function company_size_label__small(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _company_size_label__small_fr.format(args) as unknown as string;
    }

    return _company_size_label__small_fr.format(args) as unknown as string;
}

const _company_size_label__medium_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Moyenne' }],
    'fr',
);

export function company_size_label__medium(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _company_size_label__medium_fr.format(args) as unknown as string;
    }

    return _company_size_label__medium_fr.format(args) as unknown as string;
}

const _company_size_label__large_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Grande' }],
    'fr',
);

export function company_size_label__large(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _company_size_label__large_fr.format(args) as unknown as string;
    }

    return _company_size_label__large_fr.format(args) as unknown as string;
}

const _company_size_label__int_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'size',
            options: {
                '=0': { value: [{ type: 0, value: 'Inconnue' }] },
                '=1': { value: [{ type: 0, value: 'Très petite' }] },
                '=2': { value: [{ type: 0, value: 'Petite' }] },
                '=3': { value: [{ type: 0, value: 'Moyenne' }] },
                '=4': { value: [{ type: 0, value: 'Grande' }] },
                other: { value: [{ type: 0, value: 'Inconnue' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function company_size_label__int(args: { size: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _company_size_label__int_fr.format(args) as unknown as string;
    }

    return _company_size_label__int_fr.format(args) as unknown as string;
}
